import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginEmployee } from "../redux/actions/authActions";
import { useNavigate } from "react-router-dom";
import logo from "../images/wb_logo.png";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const { loading, user, error } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user, navigate]);

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(loginEmployee({ username, password }));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF3E6] via-[#FFFFFF] to-[#E8EEFF] flex flex-col items-center justify-center px-4 relative overflow-hidden">

      {/* Decorative Background Blur */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-orange-200 rounded-full blur-3xl opacity-30"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-200 rounded-full blur-3xl opacity-30"></div>

      {/* Header Section */}
      <div className="flex flex-col items-center mb-6 z-10">
        <div className="bg-white p-4 rounded-full shadow-lg border border-orange-100">
          <img src={logo} alt="Logo" className="h-20 w-20 object-contain" />
        </div>

        <div className="text-center mt-4">
          <h2 className="text-xl font-bold text-[#000080]">
            State Urban Development Agency
          </h2>

          <p className="text-sm text-gray-600 mt-1">
            Department of Urban Development & Municipal Affairs
          </p>

          <p className="text-sm font-semibold text-[#FF7500] mt-1">
            Government of West Bengal
          </p>
        </div>
      </div>

      {/* Login Card */}
      <form
        onSubmit={handleLogin}
        className="bg-white/90 backdrop-blur-lg border border-white shadow-2xl rounded-3xl w-full max-w-md p-8 z-10"
      >
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-[#000080]">
            Welcome Back
          </h2>

          <p className="text-gray-500 text-sm mt-2">
            Sign in to continue
          </p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-500 text-sm rounded-xl px-4 py-3 mb-5 text-center">
            {error}
          </div>
        )}

        {/* Username */}
        <div className="mb-5">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Username
          </label>

          <input
            type="text"
            placeholder="Enter username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-transparent transition"
            required
          />
        </div>

        {/* Password */}
        <div className="mb-6">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Password
          </label>

          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 pr-12 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition"
              required
            />

            <button
              type="button"
              className="absolute right-4 top-3 text-gray-500 hover:text-gray-700"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        {/* Login Button */}
        <button
          type="submit"
          disabled={loading}
          className={`w-full bg-gradient-to-r from-[#FF7500] to-[#00A650] text-white py-3 rounded-xl font-semibold shadow-lg hover:scale-[1.01] transition-all duration-300 ${
            loading ? "opacity-60 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>

        {/* Footer */}
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-500">
            Secure Government Authentication Portal
          </p>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;